import localhost from "apis/localhost";

const ARRAY_BUFFER = { responseType: "arraybuffer" };

const fetchBinaryDataByUrl = async (url, fileName) => {
  if (!url) {
    return null;
  }

  try {
    const rsp = await localhost.get(url, ARRAY_BUFFER);

    const contentType =
      rsp.headers?.["content-type"] || "application/octet-stream";

    const blob = new Blob([rsp.data], { type: contentType });

    return new File([blob], fileName, { type: contentType });
  } catch (err) {
    const message = "Failed to fetch document";

    const error = new Error(message);
    error.cause = err;
    throw error;
  }
};

export default fetchBinaryDataByUrl;
